import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import DashHeader from "./DashHeader";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FormikContext, useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";

function BBBEE() {
  const [formStep, setFormStep] = useState(1);

  const { userInfo } = useSelector((state) => state.userLogin);

  const smeDetails = useSelector((state) => state.userSMEDetails);
  const { sme } = smeDetails;

  const formik = useFormik({
    initialValues: {
      formType: "BBBEE",
      annualEarnings: "Less than R10 million.",
      blackOwnership: "100% Black Owned.",
    },
    onSubmit: (values) => {

      console.log(values)
      console.log(formStep)
      const api_secret_key = "TDNMSwa7U1p56gg6gEnH";
      const doctype_id = "LACOONA - BBBEE";
      const allValues = values;

      allValues["userId"] = userInfo.id;
      allValues["company_id"] = userInfo.email;
      allValues["doctype_id"] = doctype_id;
      allValues["company_name"] = sme.name;
      allValues["name"] = userInfo.name;

      /* const pdfMonkeyConfig = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${api_secret_key}`,
        },
      }; */
      setFormStep((formStep) => formStep + 1);
      /* axios
        .post(
          "https://api.pdfmonkey.io/api/v1/documents/",
          {
            document: {
              document_template_id: "DF6FCF37-6A87-4770-BFB2-56A7C26E9B17",
              payload: allValues,
              status: "pending",
            },
          },
          pdfMonkeyConfig
        )
        .then(function (response) {
          console.log("Response Received");
        })
        .catch(function (error) {
          console.log("Error Occured");
        }); */
    }
  });

  function setNextFormStep() {
    setFormStep((formStep) => formStep + 1);
  }

  function setPreviousFormStep() {
    setFormStep((formStep) => formStep - 1);
  }

  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <Helmet>
        <title>BBBEE and my Business</title>
        <meta
          name="description"
          content="Lacoona Legal helps you ensure BBBEE compliance ."
        />
        <link rel="canonical" href="/dashboard/popi" />
      </Helmet>
      <DashHeader pageTitle={"BBBEE Compliance Guidance"} />
      <Row className="dashboard-content-container">
        <Row className="bbbee-hero px-5">
        <div><LinkContainer to={"/dashboard/legal-checks"}>
              <button className="bbbee-back-button py-2 px-4">Back</button>
            </LinkContainer></div>
        
          <div className="">
            
              <h1 className="serious-font">BBBEE and my Business</h1>
            
            <Row>
              <p>
                Complete the form to determine the benefits your business could receive from BBBEE
              </p>
            </Row>
          </div>
        </Row>


        <Row className="find-a-lawyer-form-container">
          {formStep === 1 && (
            <Col className="form-step" lg={8}>
              <Row>
                <h4 className="form-step-heading">Yearly Earnings</h4>
              </Row>
              <Form>
                <div className="BBBEE-question">
                  <p className="col-5 mx-3">
                    How much does your business earn per year?
                  </p>
                  <Form.Select
                    className={
                      "BBBEE-select"
                    }
                    value={formik.values.annualEarnings}
                    name="annualEarnings"
                    onChange={formik.handleChange}
                  >
                    <option>Less than R10 million.</option>
                    <option>Between R10 and R50 million.</option>
                    <option>More than R50 million.</option>
                    </Form.Select>
                </div>
              </Form>
              <Row>
                <Col></Col>

                <Col className="form-step-next-button-container">
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={setNextFormStep}
                  >
                    Next
                  </button>
                </Col>
              </Row>
            </Col>
          )}
          {formStep === 2 && (
            <Col className="form-step" lg={8}>
              <Row>
                <h4 className="form-step-heading">Ownership Percentage</h4>
              </Row>
              <Row>
                {formik.values.annualEarnings === "Less than R10 million."&&<p>Your business will be classified as an Exempt Micro Enterprise (EME). There are different criteria that apply to EMEs.</p>}
                {formik.values.annualEarnings === "Between R10 and R50 million."&&<p>Your business will be classified as an Qualifying Small Enteprise  (QSE). There are different criteria that apply to QSEs.</p>}
              </Row>
              <Form>
                <div className="BBBEE-question">
                  <p className="col-5 mx-3">
                    What percentage of your business is black owned?
                  </p>
                  <Form.Select
                    className={
                      "BBBEE-select"
                    }
                    value={formik.values.blackOwnership}
                    name="blackOwnership"
                    onChange={formik.handleChange}
                  >
                    <option>100% Black Owned.</option>
                    <option>51% Black Owned.</option>
                    <option>50% or less Black-Owned.</option>
                    </Form.Select>
                </div>
              </Form>
              <Row>
              <Col>
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={setPreviousFormStep}
                  >
                    Back
                  </button>
                </Col>
                <Col className="form-step-next-button-container">
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={formik.handleSubmit }
                  >
                    Next
                  </button>
                </Col>
              </Row>
            </Col>
          )}

          {formStep === 3 && (
            <Col className="form-step" lg={8}>

            {formik.values.annualEarnings === "Less than R10 million." &&formik.values.blackOwnership === "100% Black Owned." &&
            <>
              <p className = "bbbee-result">Your business is classified as an Exempted Micro Enteprise and if it is 100% Black Owned, you qualify as a Level 1 BBBEE contributor (135% BBBEE procurement recognition level). This is the the peak of the BBBEE rankings.</p>
              <p className = "bbbee-result"> EMEs only need an affidavit signed by a Commissioner of Oaths which serves as a BBBEE certificate. The only criteria is your company's annual turnover (under R10 million) and the percentage black ownership. If your business is registered with CIPC you can apply for a free BBBEE certificate using this <a href = "https://www.bizportal.gov.za/bee.aspx">link</a>. Or you can download the affidavit on the CIPC <a href = "https://www.cipc.co.za/?page_id=3612">website.</a> Complete the affidavit and have it signed by a Commissioner of Oaths. The certificate is only valid for a year. It can't be renewed. Once it has expired you need to apply for a new certificate. </p>
            </>}  
            {formik.values.annualEarnings === "Less than R10 million."&&formik.values.blackOwnership === "51% Black Owned." &&
            <>
              <p className = "bbbee-result">Your business is classified as an Exempted Micro Enteprise and if it is 51% Black Owned, you automatically qualify as a Level 2 BBBEE contributor(125% BBBEE procurement recognition level).</p>
              <p className = "bbbee-result">EMEs only need an affidavit signed by a Commissioner of Oaths which serves as a BBBEE certificate. The only criteria is your company's annual turnover (under R10 million) and the percentage black ownership. If your business is registered with CIPC you can apply for a free BBBEE certificate using this <a className = "bbbee-links" href = "https://www.bizportal.gov.za/bee.aspx">link</a>. Or you can download the affidavit on the CIPC <a className = "bbbee-links" href = "https://www.cipc.co.za/?page_id=3612">website.</a> Complete the affidavit and have it signed by a Commissioner of Oaths. The certificate is only valid for a year. It can't be renewed. Once it has expired you need to apply for a new certificate.</p>
            </>
            }  
            {formik.values.annualEarnings === "Less than R10 million."&&formik.values.blackOwnership === "50% or less Black-Owned." &&
            <>
            <p className = "bbbee-result">Your business is classified as an Exempted Micro Enteprise and if it has lesss than 50% black ownership, you automatically qualify as a Level 4 BBBEE contributor (100% BBBEE procurement recognition level).</p>
            <p className = "bbbee-result"> EMEs only need an affidavit signed by a Commissioner of Oaths which serves as a BBBEE certificate. The only criteria is your company's annual turnover (under R10 million) and the percentage black ownership. If your business is registered with CIPC you can apply for a free BBBEE certificate using this <a className = "bbbee-links" href = "https://www.bizportal.gov.za/bee.aspx">link</a>. Or you can download the affidavit on the CIPC <a className = "bbbee-links" href = "https://www.cipc.co.za/?page_id=3612">website.</a> Complete the affidavit and have it signed by a Commissioner of Oaths. The certificate is only valid for a year. It can't be renewed. Once it has expired you need to apply for a new certificate.</p>
            </>
            }  

            {formik.values.annualEarnings === "Between R10 and R50 million."&&formik.values.blackOwnership === "100% Black Owned." &&
            <>
            <p className = "bbbee-result">Your business is classified as an QSE and if it is 100% Black Owned, you automatically qualify as a Level 1 BBBEE contributor (135% BBBEE procurement recognition level) and you can sign an approved affidavit. This is the peak of the BBBEE rankings.</p>
            <p className = "bbbee-result">QSEs with 100% black-ownership need a QSE affidavit signed by a Commissioner of Oaths which serves as a BBBEE certificate. The only criteria is your company's annual turnover (between R10 and R50 million) and the percentage black-ownership. CIPC does not allow QSEs to access an affidavit on their site. Use the Department of Trade and Industry <a className = "bbbee-links" href = "http://www.thedtic.gov.za/wp-content/uploads/BEE_Affidavit-QSE-Gen.pdf">link</a> for a generic QSE affidavit. Complete the affidavit and have it signed by a Commissioner of Oaths. The affidavit is only valid for a year. It can't be renewed.  </p>
            </>
            }  
            {formik.values.annualEarnings === "Between R10 and R50 million."&&formik.values.blackOwnership === "51% Black Owned." &&
            <>
            <p className = "bbbee-result">Your business is classified as QSE and if it is 51% Black Owned, you automatically qualify as a Level 2 BBBEE contributor(125% BBBEE procurement recognition level).</p>
            <p className = "bbbee-result">QSEs with 51% (up to 99%) black-ownership qualify for a level 2 BBBEE rating and need an approved BBBEE affidavit. A QSE can complete an affidavit and have it signed by a Commissioner of Oaths. The only criteria is your company's annual turnover (between R10 and R50 million) and the percentage black-ownership. Use the Department of Trade and Industry <a className = "bbbee-links" href = "http://www.thedtic.gov.za/wp-content/uploads/BEE_Affidavit-QSE-Gen.pdf">link</a> for a generic QSE affidavit. Complete the affidavit and have it signed by a Commissioner of Oaths. The Affidavit is only valid for a year. It can't be renewed.</p>
            </>
            }  
            {formik.values.annualEarnings === "Between R10 and R50 million."&&formik.values.blackOwnership === "50% or less Black-Owned." &&
            
            <>
            <p className = "bbbee-result">Your business is classified as a QSE and if it has less than 50% black ownership, you will have to be verified and rated against the scorecard.</p>
            <p className = "bbbee-result">QSEs with less than 50% black-ownership will have to demonstrate compliance with the five components of the BBBEE scorecard (Ownership, Management Control, Skills Development, Enterprise and Supplier Development, and Socio-economic Development). You will need to undergo a BBBEE verification process using a verification professional accredited by SANAS, to assess your BBBEE compliance level.  </p>

            </>
            }

          {formik.values.annualEarnings === "More than R50 million."&&
          <p className = "bbbee-result">
            GEs will have to demonstrate compliance with the five components of the BBBEE scorecard (Ownership, Management Control, Skills Development, Enterprise and Supplier Development, and Socio-economic Development). You will need to undergo a BBBEE verification process using a verification professional accredited by SANAS, to assess your BBBEE compliance level. 
            </p>}

            <Row align="center">
              <Col>
            <LinkContainer to="/dashboard/faq/54">
            <button
                    className="lcn-button-orange py-2 px-4"
                  >
                    Find out more
                  </button>
                  </LinkContainer>
                  </Col>
                  </Row>
            </Col>
            
           
          )}
        </Row>

        {formStep === 4 && (
          <Col className="form-step" lg={12}>
            <Row>
              <h4 className="form-step-heading text-center">
                Thank you for your submission. You will receive your Due
                Diligence assessment feedback in your mailbox.
              </h4>
            </Row>
          </Col>
        )}
      </Row>
    </Col>
  );
}

export default BBBEE;
